export default __webpack_public_path__ + "static/logo-27d4874048d8ddf844be610ff4235410.png";